import {Box} from "@mui/material";

export default function UIBlurBox({children} : {children: React.ReactNode}){

    return(
        <Box
                sx={{
                    background:
                        "linear-gradient(135deg, rgba(9, 9, 9, 0), rgba(9, 9, 9, 0.3) 50%, rgba(9, 9, 9, 0))",
                    lineHeight: 2,
                    borderRadius: 2,
                    backdropFilter: "blur(4px)",
                    position: "relative",
                    paddingLeft: '2px',
                    paddingRight: '2px',
                }}
            >
            {children}
        </Box>
    )
}